<template>
  <section class="mb-4 pb-4">
    <div class="container">
      <h2>Upgrade</h2>
      <div v-if="showSuccess" class="alert alert-success" role="alert">
        Sucessfully upgraded your account!
      </div>
      <div id="error-message"></div>
      <div class="pricing-type-switch">
        <ul class="nav nav-pills justify-content-center js-tabs mb-4">
          <li class="nav-item bg-white">
            <span
              class="nav-link cursor-pointer"
              v-bind:class="{ active: showingPlan === 'monthly' }"
              @click="showingPlan = 'monthly'"
              >Monthly</span
            >
          </li>
          <li class="nav-item bg-white">
            <span
              class="nav-link cursor-pointer"
              v-bind:class="{ active: showingPlan === 'yearly' }"
              @click="showingPlan = 'yearly'"
              >Yearly</span
            >
          </li>
        </ul>
      </div>
      <div class="tab-content">
        <div
          class="tab-pane"
          v-bind:class="{ active: showingPlan === 'monthly' }"
          id="monthly-plan"
          role="tabpanel"
          aria-labelledby="monthly-plan"
        >
          <div class="row">
            <div class="col-md-4">
              <div class="pricing-single">
                <div class="pricing-header">
                  <h4 class="text-center h2">Free</h4>
                  <p style="font-size: 14px" class="text-center">
                    You can try it out for free
                  </p>
                  <div class="pricing-price">
                    <div class="pricing-value" style="font-size: 60px">
                      0
                      <sup class="pricing-currency">$ per month</sup>
                    </div>
                    <span class="text-muted">Forever</span>
                  </div>
                </div>
                <ul class="pricing-list">
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>20,000</b> tracked pageview
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>200</b> visitor recording
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>30</b> days recording storage
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>unlimited</b> everything else
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    Howuku branding
                  </li>
                </ul>
                <div class="pricing-footer">
                  <button
                    v-if="getCurrentPlan() !== 'free'"
                    @click="cancel()"
                    class="btn btn-third"
                  >
                    Downgrade
                  </button>
                  <span v-else class="btn">Current plan</span>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pricing-single">
                <div class="pricing-header">
                  <h4 class="text-center h2">Basic</h4>
                  <p style="font-size: 14px" class="text-center">
                    Growing startup with smaller traffic
                  </p>
                  <div class="pricing-price">
                    <div class="pricing-value" style="font-size: 60px">
                      20
                      <sup class="pricing-currency">$ per month</sup>
                    </div>
                    <span class="text-muted">Billed Monthly</span>
                  </div>
                </div>
                <ul class="pricing-list">
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>40,000</b> tracked pageview
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>2,000</b> visitor recording
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>365</b> days recording storage
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>unlimited</b> everything else
                  </li>
                  <li
                    class="pricing-list__item disabled"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    Howuku branding
                  </li>
                </ul>
                <div class="pricing-footer">
                  <button
                    v-if="getCurrentPlan() === 'pro'"
                    @click="cancel()"
                    class="btn btn-third"
                  >
                    Downgrade
                  </button>
                  <button
                    v-if="getCurrentPlan() === 'free'"
                    class="btn btn-first"
                    id="basic"
                  >
                    Subscribe
                  </button>
                  <span v-if="getCurrentPlan() === 'basic'" class="btn"
                    >Current plan</span
                  >
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pricing-single">
                <div class="pricing-header">
                  <h4 class="text-center h2">Pro</h4>
                  <p style="font-size: 14px" class="text-center">
                    Business plan for high traffic websites
                  </p>
                  <div class="pricing-price">
                    <div class="pricing-value" style="font-size: 60px">
                      50
                      <sup class="pricing-currency">$ per month</sup>
                    </div>
                    <span class="text-muted">Billed Monthly</span>
                  </div>
                </div>
                <ul class="pricing-list">
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>100,000</b> tracked pageview
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>5,000</b> visitor recording
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>365</b> days recording storage
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>unlimited</b> everything else
                  </li>
                  <li
                    class="pricing-list__item disabled"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    Howuku branding
                  </li>
                </ul>
                <div class="pricing-footer">
                  <span v-if="getCurrentPlan() === 'pro'" class="btn"
                    >Current plan</span
                  >
                  <button v-else class="btn btn-first" id="pro">
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="tab-pane"
          v-bind:class="{ active: showingPlan === 'yearly' }"
          id="annual-plan"
          role="tabpanel"
          aria-labelledby="annual-plan"
        >
          <!-- ANNUAL PLAN -->
          <div class="row">
            <div class="col-md-4">
              <div class="pricing-single">
                <div class="pricing-header">
                  <h4 class="text-center h2">Free</h4>
                  <p style="font-size: 14px" class="text-center">
                    You can try it out for free
                  </p>
                  <div class="pricing-price">
                    <div class="pricing-value" style="font-size: 60px">
                      0
                      <sup class="pricing-currency">$ per year</sup>
                    </div>
                    <span class="text-muted">Forever</span>
                  </div>
                </div>
                <ul class="pricing-list">
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>20,000</b> tracked pageview
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>200</b> visitor recording
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>30</b> days recording storage
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>unlimited</b> everything else
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    Howuku branding
                  </li>
                </ul>
                <div class="pricing-footer">
                  <button
                    v-if="getCurrentPlan() !== 'free'"
                    @click="cancel()"
                    class="btn btn-third"
                  >
                    Downgrade
                  </button>
                  <span v-else class="btn">Current plan</span>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pricing-single">
                <div class="pricing-header">
                  <h4 class="text-center h2">Basic</h4>
                  <p style="font-size: 14px" class="text-center">
                    Growing startup with smaller traffic
                  </p>
                  <div class="pricing-price">
                    <div class="pricing-value" style="font-size: 60px">
                      200
                      <sup class="pricing-currency">$ per year</sup>
                    </div>
                    <span class="text-muted">Billed Annually</span>
                  </div>
                </div>
                <ul class="pricing-list">
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>40,000</b> tracked pageview
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>2,000</b> visitor recording
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>365</b> days recording storage
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>unlimited</b> everything else
                  </li>
                  <li
                    class="pricing-list__item disabled"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    Howuku branding
                  </li>
                </ul>
                <div class="pricing-footer">
                  <button
                    v-if="getCurrentPlan() === 'pro'"
                    @click="cancel()"
                    class="btn btn-third"
                  >
                    Downgrade
                  </button>
                  <button
                    v-if="getCurrentPlan() === 'free'"
                    class="btn btn-first"
                    id="basic_year"
                  >
                    Subscribe
                  </button>
                  <span v-if="getCurrentPlan() === 'basic'" class="btn"
                    >Current plan</span
                  >
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pricing-single">
                <div class="pricing-header">
                  <h4 class="text-center h2">Pro</h4>
                  <p style="font-size: 14px" class="text-center">
                    Business plan for high traffic websites
                  </p>
                  <div class="pricing-price">
                    <div class="pricing-value" style="font-size: 60px">
                      500
                      <sup class="pricing-currency">$ per year</sup>
                    </div>
                    <span class="text-muted">Billed Annually</span>
                  </div>
                </div>
                <ul class="pricing-list">
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>100,000</b> tracked pageview
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>5,000</b> visitor recording
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>365</b> days recording storage
                  </li>
                  <li
                    class="pricing-list__item"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    <b>unlimited</b> everything else
                  </li>
                  <li
                    class="pricing-list__item disabled"
                    data-toggle="tooltip"
                    data-replacement="right"
                  >
                    Howuku branding
                  </li>
                </ul>
                <div class="pricing-footer">
                  <span v-if="getCurrentPlan() === 'pro'" class="btn"
                    >Current plan</span
                  >
                  <button v-else class="btn btn-first" id="pro_year">
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
var stripe = Stripe('pk_live_KerNlnY1nX3c8ZeGanLHlTMS00sORk6YD9')

export default {
  mounted() {
    this.accountPlan = this.getCurrentPlan()
    window.UPGRADE_SUCCESS = false

    setTimeout(() => {
      // wait for DOM to init
      for (let i = 0; i < this.plans.length; i++) {
        console.log(this.plans[i])
        this.initPlan(this.plans[i])
      }
    }, 100)
  },
  data: function () {
    return {
      plans: ['basic', 'pro', 'basic_yearly', 'pro_yearly'],
      showSuccess: window.UPGRADE_SUCCESS,
      showingPlan: 'monthly',
      selected: this.getCurrentPlan(),
      amount: 0,
      price: 0,
      discount: 0,
      specialDiscount: 0,
      accountPlan: '',
      anual: true,
    }
  },
  methods: {
    cancel() {
      this.$http
        .post(process.env.API_ENDPOINT + '/subscription/cancel', {})
        .then((response) => {
          alert('cancelled')
        })
    },
    initPlan(plan) {
      try {
        var checkoutButton = document.getElementById(plan)
        checkoutButton.addEventListener('click', () => {
          stripe
            .redirectToCheckout({
              clientReferenceId: this.$session.get('company_id').toString(),
              items: [
                {
                  plan: plan,
                  quantity: 1,
                },
              ],
              successUrl: 'http://app.howuku.com/#/payment/success',
              cancelUrl: 'http://app.howuku.com/#/upgrade',
            })
            .then(function (result) {
              if (result.error) {
                var displayError = document.getElementById('error-message')
                displayError.textContent = result.error.message
              }
            })
        })
      } catch (err) {}
    },
    getCurrentPlan() {
      let plan = this.$session.get('paid_plan')
      let name = 'free'
      if (plan === 1) name = 'basic'
      if (plan === 2) name = 'pro'
      return name
    },
    setPlan(name) {
      this.selected = name
      let month = 1
      let discount = 1
      if (this.anual) {
        month = 12
        discount = 0.9
      }
      if (this.specialDiscount) {
        discount = this.specialDiscount
      }
      if (name === 'free') this.price = 0
      if (name === 'basic') this.price = 10
      if (name === 'pro') this.price = 40

      this.price = this.price * month
      this.amount = this.price * discount
      this.discount = this.price - this.amount
    },
    nextYear() {
      return this.$userTimeNow()
        .add(1, 'year')
        .add(1, 'day')
        .format('DD MMMM, Y')
    },
  },
}
</script>

<style>
.bg-white .active {
  background-color: transparent !important;
}

.pricing-section .tab-content {
  margin-top: 40px;
  margin-bottom: 200px;
}

.pricing-type-switch .nav-link {
  background: transparent;
  border-bottom: 2px solid #dddddd;
  border-radius: 0;
  color: #637282;
  padding-right: 15px;
  padding-left: 15px;
  font-size: 30px;
}

.pricing-type-switch .nav-link.active {
  background: transparent;
  color: #1b2733;
  border-bottom-color: #2167f5;
}

.pricing-single {
  border-radius: 2px;
  padding: 30px;
  -webkit-box-shadow: 0 0 20px rgba(27, 39, 51, 0.2);
  box-shadow: 0 0 20px rgba(27, 39, 51, 0.2);
}

.pricing-header {
  margin-bottom: 10px;
}

.pricing-title {
  text-align: center;
  display: block;
  margin-bottom: 20px;
  font-size: 22px;
  color: #1b2733;
}

.pricing-price {
  margin-bottom: 20px;
  color: #1b2733;
  text-align: center;
}

.pricing-price small {
  display: block;
  color: #637282;
}

.pricing-value {
  font-weight: bold;
  font-size: 56px;
  line-height: 58px;
  font-family: 'Rubik', sans-serif;
}

.pricing-currency {
  font-size: 18px;
  top: -28px;
  left: -10px;
  font-weight: normal;
  position: relative;
}

.pricing-list {
  list-style-type: none;
}

.pricing-list .disabled {
  text-decoration: line-through;
  color: rgba(99, 114, 130, 0.5);
}

.pricing-list__item {
  color: #2c3641;
  margin: 10px 0;
  position: relative;
}

.pricing-list__item:before {
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(27, 39, 51, 0.3);
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}

.pricing-footer {
  text-align: center;
  margin-top: 40px;
  padding-bottom: 20px;
}

.pricing-footer .assistive-text {
  font-size: 12px;
  margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Payment.vue